var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper d-inline" },
    [
      _c(
        "span",
        {
          staticClass: "badge text-uppercase font-weight mr-1 cursor-pointer",
          class: _vm.getBadgeClass,
          on: {
            click: function ($event) {
              _vm.show = !_vm.show
            },
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm._f("uppercase")(_vm.getEventTypeText)) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.show
        ? _c("additional-data", {
            attrs: { items: _vm.getItems, "received-at": _vm.getReceivedAt },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }